import { getExtendedReport } from '../../../../../api/projectApi';
import { PMR_MOD_REPORT, TCDI_MOD_REPORT } from '../Config/OnePagerConfig';
import { generatePdfExtendedProjectReport } from '../Generators/ExtendedProjectReportGenerator';

export const downloadExtendedProjectReport = async (currentProject, sections, isPMRType, setIsLoading) => {
  if (!currentProject) return;

  const modReport = isPMRType ? PMR_MOD_REPORT : TCDI_MOD_REPORT;

  const reportData = await getExtendedReport(currentProject, modReport);

  if (!reportData) {
    console.error('No data received from getProjectAndSummaryReports, aborting PDF generation.');
    return;
  }

  await generatePdfExtendedProjectReport({ data: reportData, sections, isPMRType, onLoading: setIsLoading });
};